import React, {PureComponent, ComponentClass, RefObject} from "react"
import {ScreenContext} from "./ScreenContext"

export interface ValidatedScreenProps {
  forwardedRef?: any
}

export default function validatedScreen<Props>(
  Screen: React.ComponentType<Props & ValidatedScreenProps>,
  displayName: string,
  {withRef = false} = {}
): ComponentClass<Pick<Props, Exclude<keyof Props, keyof ValidatedScreenProps>>> & {
  WrappedComponent: React.ComponentType<Props & ValidatedScreenProps>
} {
  type PrivateProps = {
    forwardedRef?: RefObject<typeof Screen>
  }

  type State = {
    errors: any
  }

  class ValidatedScreen extends PureComponent<PrivateProps & Props, State> {
    static navigationOptions = Screen.navigationOptions

    render() {
      const {forwardedRef} = this.props
      return (
        <ScreenContext.Provider value={displayName}>
          <Screen {...this.props} ref={forwardedRef} />
        </ScreenContext.Provider>
      )
    }
  }

  if (withRef) {
    return function ValidatedScreenRef({ref, ...props}: Props & {ref?: React.Ref<typeof Screen>}) {
      return <ValidatedScreen {...props} forwardedRef={ref} />
    }
  }

  return ValidatedScreen
}
